import { ApolloClient, ApolloLink, HttpLink } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { onError } from '@apollo/client/link/error'

import cache from './cache'

const httpLink = new HttpLink({ uri: `${process.env.REACT_APP_API_URL}/graphql` })
// const httpLink = new HttpLink({ uri: `http://aaaaaa.fe01tstguia.srv.ama.lan:3000/graphql` })

const authLink = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext({
    headers: {
      authorization: localStorage.getItem('ia.tic.gov.pt-access_token')
        ? `Bearer ${JSON.parse(localStorage.getItem('ia.tic.gov.pt-access_token'))}`
        : null
    }
  })

  return forward(operation)
})

const errorLink = onError(({ graphQLErrors, networkError }) => {
  if (graphQLErrors) {
    graphQLErrors.forEach(({ message, locations, path }) => {
      if (message.includes('401 Unauthorized')) {
        // @TODO redirect to login
        console.log(`[GraphQL error]: 401 Unauthorized`)
      } else {
        console.error(`[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`)
      }
    })
  }
  if (networkError) {
    if (networkError.statusCode === 401) {
      if (window.location.pathname !== '/login') {
        window.location.pathname = '/login'
      }
    } else if (networkError.statusCode === 500) {
    } else {
      console.error(`[Network error]: ${networkError}`)
    }
  }
})

const omitTypename = (key, value) => {
  return key === '__typename' || key === '_id' || /^\$/.test(key) ? undefined : value
}

const omitTypenameLink = new ApolloLink((operation, forward) => {
  if (operation.variables) {
    operation.variables = JSON.parse(JSON.stringify(operation.variables), omitTypename)
  }
  return forward ? forward(operation) : null
})

const retryLink = new RetryLink({
  delay: {
    initial: 1000,
    max: Infinity,
    jitter: true
  },
  attempts: {
    max: 50,
    retryIf: (error, _operation) => error.name === 'TypeError' || error.statusCode === 504
  }
})

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([errorLink, retryLink, authLink, omitTypenameLink, httpLink])
})
